module.exports = __webpack_public_path__ + "assets/images/rbyearend-13.jpg?v=cc365db3";